import { useState } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import CodeEditor from 'hb-react/backoffice/components/CodeEditor';

const HtmlSettings = ({
  item,
  onChange,
}: Pick<ComponentSettingsTab, 'item' | 'onChange'>) => {
  const [value, setValue] = useState(item.content);

  const handleChange = (value) => {
    setValue(value);

    onChange({
      id: item.id,
      settingKey: 'content',
      value,
    });
  };

  return (
    <Wrapper>
      <CodeEditor
        fontSize={13}
        height="100%"
        onChange={handleChange}
        options={{
          showLineNumbers: true,
        }}
        showGutter
        tabSize={2}
        value={value}
        wrapEnabled
      />
    </Wrapper>
  );
};

export default HtmlSettings;

const Wrapper = styled(Box).attrs(() => ({
  alignItems: 'center',
  flex: 1,
  flexDirection: 'column',
  height: 500,
  p: 4,
  width: '100%',
}))``;
